import { page } from '$app/state';
import { event } from '$lib/utils/tracking';

export default function captureClick(node: HTMLElement) {
	function handleClick({ target }: MouseEvent) {
		const element = target as HTMLElement;

		const pathname = page.url.pathname;

		const buttonElement = element.closest('a') || element.closest('button') || element;

		if (buttonElement.tagName === 'BUTTON') {
			event('CTA Button Click', {
				path: pathname,
				text: buttonElement.innerText,
				title: buttonElement.getAttribute('title') || ''
			});
			return;
		}

		event('CTA Link Click', {
			path: pathname,
			text: buttonElement.innerText,
			href: buttonElement.getAttribute('href') || ''
		});
	}

	node.addEventListener('click', handleClick);

	return {
		destroy() {
			node.removeEventListener('click', handleClick);
		}
	};
}
